<template>
  <div class="macros-panel">
    <!-- Header with integrated tabs -->
    <div class="macros-header">
      <div class="header-top">
        <h3 class="header-title">
          {{ $t('CONVERSATION_SIDEBAR.ACCORDION.MACROS') }}
        </h3>
        <woot-button
          v-if="showCloseButton"
          icon="dismiss"
          class="close-button"
          variant="clear"
          color-scheme="secondary"
          size="small"
          @click="$emit('close')"
        />
      </div>
      <div class="macros-tabs">
        <button
          class="macros-tab"
          :class="{ active: activeTab === 'normal' }"
          @click="activeTab = 'normal'"
        >
          {{ $t('MACROS.TABS.NORMAL') || 'Normal' }}
        </button>
        <button
          class="macros-tab"
          :class="{ active: activeTab === 'ai' }"
          @click="activeTab = 'ai'"
        >
          {{ $t('MACROS.TABS.AI') || 'AI Macros' }}
        </button>
      </div>
    </div>
    <!-- Content -->
    <div class="macros-content">
      <macros-list
        v-if="activeTab === 'normal'"
        :conversation-id="conversationId"
        filter-type="normal_api_call"
        class="min-h-[25vh]"
        @use-response="handleMacroResponse"
      />
      <macros-list
        v-if="activeTab === 'ai'"
        :conversation-id="conversationId"
        filter-type="ai_agents"
        class="min-h-[25vh]"
        @use-response="handleMacroResponse"
      />
    </div>
  </div>
</template>

<script>
import MacrosList from './List';

export default {
  name: 'MacrosPanel',
  components: {
    MacrosList,
  },
  props: {
    conversationId: {
      type: [Number, String],
      required: true,
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      activeTab: 'normal',
    };
  },
  methods: {
    handleMacroResponse(messageBody) {
      this.$emit('use-response', messageBody);
    },
  },
};
</script>

<style lang="scss" scoped>
.macros-panel {
  @apply flex flex-col h-full;
}

.macros-header {
  @apply sticky top-0 z-10 bg-white dark:bg-slate-800 shadow-sm;
}

.header-top {
  /* items-start: title + close align to the top of this row (no vertical float).
   * pt-3 balances air under the modal’s rounded top without the old “floating” gap. */
  @apply flex items-start justify-between gap-2 px-4 pt-3 pb-2;
}

.header-title {
  @apply text-base font-semibold leading-tight text-slate-800 dark:text-slate-100 m-0;
}

.close-button {
  @apply p-1;
}

.macros-tabs {
  @apply flex px-4 pb-0 bg-white dark:bg-slate-800;
}

.macros-tab {
  @apply flex-1 py-2.5 px-4 text-sm font-medium text-slate-600 dark:text-slate-300 
         bg-transparent border-0 border-b-2 border-transparent cursor-pointer 
         transition-all duration-200 ease-in-out rounded-t-md;

  &:hover {
    @apply text-slate-800 dark:text-slate-100 bg-slate-50 dark:bg-slate-700/50;
  }

  &.active {
    @apply text-woot-500 dark:text-woot-400 border-woot-500 dark:border-woot-400 
           bg-woot-25 dark:bg-woot-800/20;
  }
}

.macros-content {
  @apply flex-1 overflow-visible;
}
</style>
